import React, { useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, AllCommunityModule, ModuleRegistry, themeBalham } from 'ag-grid-community';
import { TClientSap } from '../../../utils/types/tables/TClientSap';

ModuleRegistry.registerModules([AllCommunityModule]);

interface TClientSapGridProps {
    clients: TClientSap[];
    isLoading?: boolean;
}

const TClientSapGrid: React.FC<TClientSapGridProps> = ({ clients, isLoading }) => {
    const gridRef = useRef<AgGridReact>(null);

    useEffect(() => {
        if (!gridRef.current?.api) return;
        if (isLoading) {
            gridRef.current.api.showLoadingOverlay();
        } else if (!clients.length) {
            gridRef.current.api.showNoRowsOverlay();
        } else {
            gridRef.current.api.hideOverlay();
        }
    }, [isLoading, clients]);

    const columnDefs: ColDef<TClientSap>[] = [
        {
            field: 'nomClient',
            headerName: 'Nom Client',
            sortable: true,
            filter: true,
        },
        {
            field: 'nomListePrix',
            headerName: 'Liste de prix',
            sortable: true,
            filter: true,
        },
    ];

    const myTheme = themeBalham.withParams({ columnBorder: { style: 'dashed', width: '1px' } });

    const handleGridReady = (params: any) => {
        params.api.autoSizeAllColumns();
        if (isLoading) {
            params.api.showLoadingOverlay();
        }
    };

    return (
        <div style={{ height: '100vh', width: '100%' }}>
            <AgGridReact
                ref={gridRef}
                theme={myTheme}
                getRowId={(params) => params.data.id?.toString() ?? ''}
                rowData={isLoading ? [] : clients}
                columnDefs={columnDefs}
                pagination
                domLayout="normal"
                defaultColDef={{ resizable: true, editable: false, minWidth: 100, flex: 1 }}
                onGridReady={handleGridReady}
                enableCellTextSelection
                ensureDomOrder
                animateRows
                loadingOverlayComponent={() => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div
                            style={{
                                width: 20,
                                height: 20,
                                border: '3px solid #ccc',
                                borderTop: '3px solid #2196f3',
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite',
                            }}
                        />
                        <span>Chargement...</span>
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    </div>
                )}
                overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>"
            />
        </div>
    );
};

export default TClientSapGrid;
